require('./RAHireManagementPlanSuccess.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const RAPortfolioDonut = require('../../RAPortfolioDonut/RAPortfolioDonut');
const RAGoalHiringSummary = require('../../RAGoalSummary/RAGoalHiringSummary');
const RAHireFundTable = require('../../commons/RAHireFundTable/RAHireFundTable');
const RAOneLineSymbolAmount = require('../../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { recordProcess } = require('utilities/tagging');

// @Contact Center
const { traceFlowEvent } = require('utilities/contactCenter/wrapUp/wrapUpCore');
const {
    OPERATION_LOG_TYPE_FINISH,
    OPERATION_LOG_DONE,
} = require('utilities/contactCenter/wrapUp/constants');

// @constants
const { RA_INVESTMENT_TYPE_FOUNDS } = require('../../../raConstants/index');

class RAHireManagementPlanSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accordionExpanded: false,
        };
        this.handleExpand = this.handleExpand.bind(this);
    }

    componentDidMount() {
        scrollToTop();
        if (__CONTACT_CENTER__) {
            traceFlowEvent.notify(
                OPERATION_LOG_TYPE_FINISH,
                OPERATION_LOG_DONE,
            );
        }
        const customData = {
            event_name: 'step_success',
            pageName: '/contractingRobo/success',
            sectionFamily: 'wealth',
            sectionCategory: 'products',
            sectionName: 'robo',
            serviceType: 'productContracting',
            interactionType: 'funnel',
            processType: 'contractingRobo',
            processStep: 'success',
            productName: 'robo',
        };
        recordProcess('', '', customData, true);
    }

    handleExpand() {
        this.setState({
            accordionExpanded: !this.state.accordionExpanded,
        });
    }

    buildGoalSummary(immHireManagementPlan, immHiringFlowData, hasObjective) {
        if (hasObjective) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="ra-hire-management-plan-success__section-title">
                            <FormattedText value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_goalTitle" />
                        </h2>
                        <div className="ra-hire-management-plan-success__section-gbi">
                            <RAGoalHiringSummary
                                immHiringFlowData={immHiringFlowData}
                                immHireManagementPlan={immHireManagementPlan}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }

    buildAccordionHeader(selectedAccountsWithFunds) {
        const fundsQuantity = selectedAccountsWithFunds.reduce(
            (acc, immAcc) => acc + immAcc.size,
            0,
        );
        return (
            <div>
                <div className="ra-accordion-distribution-table__header-col ra-accordion-distribution-table__header-col--first">
                    <span className="ra-accordion-distribution-table__header-primary-text">
                        <FormattedText value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_accordionHeader" />
                    </span>
                    <span className="ra-accordion-distribution-table__header-content-secondary">
                        <FormattedText
                            value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_fundsQuantity"
                            injectedStrings={[fundsQuantity]}
                        />
                    </span>
                </div>
            </div>
        );
    }

    buildDescriptionBlock() {
        const {
            immHireManagementPlan,
            availableAccountsWithFunds,
        } = this.props;

        const selectedAccountsWithFunds = immHireManagementPlan.get(
            'selectedAccountsWithFunds',
        );
        const fundsTotalAmount = immHireManagementPlan.get('fundsTotalAmount');
        const investmentType = immHireManagementPlan.getIn([
            'steps',
            0,
            'investmentType',
        ]);
        const accordionHeader = this.buildAccordionHeader(
            selectedAccountsWithFunds,
        );
        const formattedAmount = {
            amount: fundsTotalAmount,
            currency: 'EUR',
        };
        const content =
            investmentType === RA_INVESTMENT_TYPE_FOUNDS ? (
                <div className="col-md-12">
                    <div className="col-md-12">
                        <Accordion customClassName="ra-hire-management-plan-success__accordion">
                            <AccordionHeader
                                name="AccordionHeader"
                                isExpanded={this.state.expandedRow}
                                expandAccordionRow={this.handleExpand} // eslint-disable-line
                            >
                                {accordionHeader}
                            </AccordionHeader>
                            <AccordionBody name="AccordionBody">
                                <div className="ra-hire-management-plan-success__accordion-body">
                                    <RAHireFundTable
                                        availableAccountsWithFunds={
                                            availableAccountsWithFunds
                                        }
                                        selectedAccount="ALL"
                                        selectedAccountsWithFunds={
                                            selectedAccountsWithFunds
                                        }
                                        updateSelectedAccountsWithFunds={
                                            this.updateSelectedAccountsWithFunds
                                        }
                                        showAccountHeader={false}
                                        filterSelectedAccounts={true}
                                        fundsTotalAmount={fundsTotalAmount}
                                    />
                                </div>
                            </AccordionBody>
                        </Accordion>
                        <div className="ra-hire-management-plan-success__footer-row">
                            <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_totalFunds" />
                            <div className="ra-hire-management-plan-success__footer-wrapper">
                                <RAOneLineSymbolAmount
                                    amountObject={formattedAmount}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ) : null;
        return content;
    }

    render() {
        const {
            immAssetAllocations,
            immHireManagementPlan,
            immHiringFlowData,
            hasObjective,
            investProfileValue,
            investorProfile,
            investorProfileDescription,
        } = this.props;
        const goalSummary = this.buildGoalSummary(
            immHireManagementPlan,
            immHiringFlowData,
            hasObjective,
        );
        const strategyName = formatText(
            `raStrategyItem-raStrategyItem_${investProfileValue}`,
        );
        let subTitleInvestment = hasObjective
            ? 'subTitleInvestmentGoal'
            : 'subTitleInvestment';
        subTitleInvestment =
            'raHireManagementPlanSuccess-raHireManagementPlanSuccess_' +
            subTitleInvestment;
        const descriptionBlock = this.buildDescriptionBlock();
        return (
            <div className="ra-hire-management-plan-success">
                {goalSummary}
                {descriptionBlock}
                <div className="col-md-12">
                    <div className="col-md-12">
                        <div className="ra-hire-management-plan-success__section-donut">
                            <h2 className="ra-hire-management-plan-success__section-title-donut">
                                <FormattedText
                                    value={subTitleInvestment}
                                    injectedStrings={[strategyName]}
                                />
                            </h2>
                            <RAPortfolioDonut
                                immAssetAllocations={immAssetAllocations}
                            />
                            <div className="ra-hire-management-plan-success__section-profile">
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="ra-hire-management-plan-success__info-icon-container">
                                            <span className="ra-hire-management-plan-success__info-icon">
                                                <FormattedText
                                                    value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_subTitleInfoProfile"
                                                    injectedStrings={[
                                                        investorProfile,
                                                    ]}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="ra-hire-management-plan-success__info-profile">
                                            {investorProfileDescription}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ContactCenterRender>
                            <BlockInfo extraClass="ra-hire-management-plan-success__cc-message">
                                <FormattedText value="cc_raHireManagementPlanSuccess-successMessage" />
                            </BlockInfo>
                        </ContactCenterRender>
                    </div>
                </div>
            </div>
        );
    }
}

RAHireManagementPlanSuccess.propTypes = {
    immAssetAllocations: PropTypes.object.isRequired,
    immHireManagementPlan: PropTypes.object.isRequired,
    immHiringFlowData: PropTypes.object.isRequired,
    investorProfile: PropTypes.string.isRequired,
    investorProfileDescription: PropTypes.string.isRequired,
    hasObjective: PropTypes.bool.isRequired,
    investProfileValue: PropTypes.number.isRequired,
    availableAccountsWithFunds: PropTypes.object,
};

module.exports = RAHireManagementPlanSuccess;
